import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import router from './router';
import mitt from 'mitt';
import './assets/styles/base.scss';

// Create pinia instance
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// Keep mitt for now during migration
const emitter = mitt();

const app = createApp(App);
app.use(pinia);
app.use(router);

// Temporary - keep these during migration
let logged_in = false;
app.config.globalProperties.$logged_in = logged_in;
app.config.globalProperties.$emitter = emitter;

// Initialize auth state after pinia is ready
import('./stores/auth').then(({ useAuthStore }) => {
  const authStore = useAuthStore();
  authStore.checkAuth().then((data) => {
    if (data && data.username) {
      logged_in = true;
      emitter.emit('loginStatusChanged', logged_in);
    }
  }).catch((err) => {
    console.error(`Error calling whoami: ${err.message}`);
  });
});

// Initialize realtime connection for all users (including anonymous)
import('./stores/realtime').then(({ useRealtimeStore }) => {
  const realtimeStore = useRealtimeStore();
  realtimeStore.detectFeatures();
  
  // Delay connection slightly to ensure stores are ready
  setTimeout(() => {
    import('./services/RealtimeService').then(({ default: realtimeService }) => {
      realtimeService.connect();
    });
  }, 1000);
});

emitter.on('loginStatusChanged', (status) => {
  logged_in = status;
  app.config.globalProperties.$logged_in = status;
});

window.app = app;
app.mount('#app');
